<template>
  <div>
    <period-lock-main></period-lock-main>
  </div>
</template>

<script>
import PeriodLockMain from "@/components/ecologist/periodLock/periodLockMain.vue";
export default {
  name: "periodLockMainView",
  components: { PeriodLockMain },
};
</script>

<style scoped></style>
